import { useEffect, useState } from 'react';

const closeGlobalToggleEvent = 'closeGlobalToggle';
export const closeGlobalToggles = () => {
  document.dispatchEvent(new Event(closeGlobalToggleEvent));
};

export default function useGlobalToggle(ref, initialState = false) {
  const [isOpen, setOpen] = useState(initialState);

  useEffect(() => {
    // Only bind event handlers once open is true as a minor optimization
    if (!isOpen) return;

    const close = () => setOpen(false);

    const handleClickOutside = event => {
      if (ref.current != null && !ref.current.contains(event.target)) {
        close();
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener(closeGlobalToggleEvent, close);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener(closeGlobalToggleEvent, close);
    };
  }, [isOpen]);

  return [isOpen, setOpen];
}
